

























import { Component, Prop, Vue } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
@Component({
  name: 'lb-container',
  components: {
    VuePerfectScrollbar
  }
})
export default class extends Vue {
  @Prop({ default: '100%' }) private width!: string;
  @Prop({ default: '500px' }) private height!: string;
  @Prop() private maxHeight!: string;
  @Prop() private minWidth!: string;
  @Prop({ default: '' }) private type!: string;
  @Prop({ type: Boolean, default: false }) private loading!: boolean;
  @Prop({ type: Boolean, default: false }) private loadEnd!: boolean;
  @Prop({ type: Boolean, default: true }) private isOut!: boolean;
  @Prop({ type: Boolean, default: false }) private xTop!: boolean;

  private settings = {
    wheelPropagation: true,
    minScrollbarLength: 50,
    swipeEasing: false
  };

  private setStyle() {
    if (this.maxHeight) {
      return {'width': this.width, 'max-height': this.maxHeight, 'min-width': this.minWidth}
    } else {
      return {'width': this.width, 'height': this.height, 'min-width': this.minWidth}
    }
  }

  private handleYStart() {
    this.$emit('y-start');
  }

  private handleYEnd() {
    if (!this.loading && !this.loadEnd) {
      this.$emit('y-end');
    }
  }

  private handleXStart() {
    this.$emit('x-start');
  }

  private handleXEnd() {
    this.$emit('x-end');
  }
}
